<template>
    <ul>
        <li class="menu__item divider--before">
            <router-link :to="{ name: 'markets' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-chevron-right"></i>
                <span>Markets</span>
            </router-link>
        </li>
        <li class="menu__item divider--before">
            <router-link :to="{ name: 'settings' }" @click.native="toggleMobileMenu" class="menu__link">
                <i class="breadcrumb__icon mdi mdi-settings"></i>
                <span>Instellingen</span>
            </router-link>
        </li>
        <li class="menu__item">
            <div @click.prevent="logout" class="menu__link">Log out</div>
        </li>
    </ul>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import vMediaQuery from 'v-media-query';

    import firebase from 'firebase';

    @Component({
    })
    export default class General extends Vue {
        name = 'general-menu';

        showMobileMenu = true;

        logout() {
            firebase.auth().signOut().then(() => {
                this.$router.go({name: 'signin'});
            })
        }

        toggleMobileMenu() {

        }
    }

    Vue.component('general-menu', General);
</script>

<style src="./styles.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/general/menu/General.vue